import { callPermissionDetailState } from '../../models/callModel';
import { Types }from '../action/action';

const initialState = {
  isSuccess: false,
  flipDeviceInfo: [],
  recordingPermission : []
};

export const callPermissionDetail = (state:callPermissionDetailState  = initialState, action: any) => {
  const {
    type,
    payloads
  } = action;
  switch (type) {
  case Types.GET_CALL_FLIP_DETAIL:
    return {
      ...state, flipDeviceInfo: payloads, isSuccess: true
    };
  case Types.GET_CALL_RECORD_DETAIL:
    return {
      ...state, recordingPermission: payloads, isSuccess: true
    };
  default:
    return state;
  };
};